import React, { Component } from "react";
import { GenerateKey } from "../GenerateKey/generatekeymodal";
import { GenerateKeyV2 } from "../GenerateKey/generatekeymodalV2";

import { Redirect, Link } from "react-router-dom";

class HomePage extends Component {
    state = {
        loggedIn: true,
        license_modal_version:''
    }

    componentDidMount(){
        this.setState({loggedIn: localStorage.getItem('login')})
    }

    handleOpenModal = (modal_type) => {
        this.setState({license_modal_version:modal_type})
    }

    handleCloseModal = () => {
        this.setState({license_modal_version:''})
    }

    render() {
        if(!this.state.loggedIn){
            return <Redirect to="/login" />
        }
        return (
            <div className="Login" style={{ padding: '0px' }}>
                {/* <nav className="navbar navbar-light bg-light">
                    <a className="navbar-brand" href="#">
                    <img src="favicon.ico" width="30" height="30" style={{ margin: '0px 10px' }} className="d-inline-block align-top" alt="" />
                        VAST License Server
                    </a>
                </nav> */}
                <div className="row">
                    <div className="col-sm-6" style={{padding: '35px'}}>
                        <div className="card text-center">
                        <div className="card-body">
                            <h5 className="card-title">Generate License Key</h5>
                            <p className="card-text">Generate a New License Key for Customer.</p>
                            <div className="d-flex justify-content-center" style={{gap:"30px"}}>
                                <button
                                    className='btn btn-primary'
                                    style={{ height: '35px', marginTop: '7px' }}
                                    // data-toggle="modal"
                                    // data-target="#genrate_key_modal"
                                    // data-backdrop="static"
                                    onClick={()=>this.handleOpenModal('v1')}
                                    >
                                    Generate V1
                                </button>

                                <button
                                    className='btn btn-primary'
                                    style={{ height: '35px', marginTop: '7px' }}
                                    onClick={()=>this.handleOpenModal('v2')}
                                    // data-toggle="modal"
                                    // data-target="#genrate_key_modalv2"
                                    // data-backdrop="static"
                                >
                                    Generate V2
                                </button>
                            </div>
                            {
                                this.state.license_modal_version == 'v1'
                                &&
                                <GenerateKey 
                                    handleCloseModal={this.handleCloseModal}
                                    open={true}
                                />
                            }
                            {
                                this.state.license_modal_version == 'v2'
                                &&
                                <GenerateKeyV2 
                                    handleCloseModal={this.handleCloseModal}
                                    isEdit={false}
                                    vast_id={null}
                                    open={true}
                                />
                            }

                        </div>
                        </div>
                    </div>
                    <div className="col-sm-6" style={{padding: '35px'}}>
                        <div className="card text-center">
                        <div className="card-body">
                            <h5 className="card-title">License Key Dashboard</h5>
                            <p className="card-text">View all the License Keys that are Generated/Activated</p>
                            <Link to="/dashboard"><button className='btn btn-primary' style={{ height: '35px', marginTop: '7px' }}>Dashboard</button></Link>
                        </div>
                        </div>
                    </div>
                </div>
            </div>


        );
    }

};

export default(HomePage);